/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Knp_Terms_Add_Term_FailedInputs */



/**
* | output |
* | --- |
* | "Failed to add term: {error}" |
*
* @param {Knp_Terms_Add_Term_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_add_term_failed = /** @type {((inputs: Knp_Terms_Add_Term_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Add_Term_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Échec de l’ajout du terme : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Term konnte nicht hinzugefügt werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile aggiungere il termine: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось добавить термин: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se pudo agregar el término: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`添加术语失败：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`用語の追加に失敗しました: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`टर्म जोड़ने में विफल: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha ao adicionar o termo: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Failed to add term: ${i?.error}`)
});